/**
 * 
 * @param {string} name Le nom de l'évènement a envoyer. Doit être un slug 
 * @param {*} detail 
 */
const sendSimpleEvent = (name,detail) => {
  if (window.dataLayer !== undefined) {
    const eventName = name.includes('cdm_')?name:'cdm_'+name;
    dataLayer.push({event:eventName,event_detail:detail});
  }
}


const listen = () => {

  /**
   * Évènement pour le module newsletter
   */
  document.querySelectorAll('.newsletter_gtm_event').forEach((el)=>{
    el.addEventListener('click',()=>sendSimpleEvent('cdm_newsletter_subscription'))
  })

  /**
   * Écoute le document pour l'évènement contact form 7 d'envoi de form
   */
  document.addEventListener("wpcf7mailsent",(e)=>{
    sendSimpleEvent('cdm_contact_form_sent',e.detail.apiResponse.form_title)
  });

  /**
   * Permet de déclarer les events directement en attributs
   * ajouter l'attribut data-gtag avec le nom de l'event
   * ajouter l'attribut data-gtag-listen pour écouter un évènement autre que click
   * ajouter l'attribut data-gtag-detail pour ajouter un détail sur l'évènement
   */
  document.querySelectorAll("[data-gtag]").forEach((el)=>{
    const name = el.getAttribute('data-gtag');
    const event = el.getAttribute('data-gtag-listen') ?? 'click';
    const detail = el.getAttribute('data-gtag-detail');
    el.addEventListener(event,(e)=>{
      e.preventDefault();
      sendSimpleEvent(name,detail);
    })
  })
  
  /**
   * Envoi les click sur les liens tel: et ajoute le numéro cliqué en details
   */
  document.querySelectorAll("[href*='tel:']").forEach((el)=>{
    const detail = el.getAttribute('href').replace('tel:','');
    el.addEventListener('click',(e)=>{
      e.preventDefault();
      sendSimpleEvent('cdm_tel_clicked',detail);
      location.href =  el.getAttribute('href');
    })
  })


  /**
   * Envoi les click sur les liens mailto: et ajoute le email cliqué en details
   */
  document.querySelectorAll("[href*='mailto:']").forEach((el)=>{
    const detail = el.getAttribute('href').replace('mailto:','');;
    el.addEventListener('click',(e)=>{
      e.preventDefault();
      sendSimpleEvent('cdm_mailto_clicked',detail);
      location.href =  el.getAttribute('href');
    })
  })

  /**
   * Envoi les click sur les liens de dirtections du thème et ajoute le l'adresse cliqué en details
   */
  document.querySelectorAll("a[data-direction]").forEach((el)=>{
    const detail = el.getAttribute('data-direction');
    el.addEventListener('click',(e)=>{
      e.preventDefault();
      sendSimpleEvent('cdm_direction_clicked',detail);
      if(el.getAttribute('target') && el.getAttribute('target') == "_blank"){
        window.open(el.getAttribute('href'), '_blank');
      }
      else{
        location.href =  el.getAttribute('href');
      }
    })
  })
};

export default {listen,sendSimpleEvent}